import React from "react";
import { useTranslation } from 'react-i18next';
import style from "./NotificationPermissionRequest.module.scss";
import { BellRing } from 'lucide-react';

const NotificationRequestModal = ({ onAllow, onDeny }) => {
  const { t } = useTranslation();
  
  return (
    <div className={style.overlay}>
      <div className={style.card}>
        <div className={style.iconContainer}>
          <div className={style.bellIcon}>
            <BellRing size={36} color="#ffffff" style={{ fill: 'white' }} />
          </div>
        </div>
        
        <h2 className={style.title}>
          Хотите получать важные уведомления?
        </h2>
        
        <p className={style.subtitle}>
          Мы отправляем только полезные обновления: изменения заказа, акции и напоминания.<br />
          Вы всегда сможете отключить уведомления позже.
        </p>
        
        <div className={style.buttons}>
          <button className={style.denyButton} onClick={onDeny}>
            Нет, спасибо
          </button>
          <button className={style.allowButton} onClick={onAllow}>
            Да, включить уведомления
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationRequestModal;